import opentype from 'opentype.js'

let sharedSheet: CSSStyleSheet | null = null;
let structureViewEnabled: boolean = true;
let notesCollapsed: boolean = true;
let originalStylesEnabled: boolean = true;

export function setSharedStyles(sheet: CSSStyleSheet, dataAttributeSelector: string | false = false) {
  if(dataAttributeSelector) sheet = convertSelectorToDataAttributeSelector(sheet, dataAttributeSelector)
  sharedSheet = sheet;
}

function convertSelectorToDataAttributeSelector(sheet: CSSStyleSheet, dataAttributeSelector: string): CSSStyleSheet {
  for(let i = 0; i < sheet.cssRules.length; i++) {
    if(sheet.cssRules[i].STYLE_RULE) {
      const rule : CSSStyleRule = sheet.cssRules[i] as CSSStyleRule;
      rule.selectorText = `[${dataAttributeSelector}="${rule.selectorText.split('.').pop()}"]`
    }
  }
  return sheet
}

export function getSharedStyles(): CSSStyleSheet | null {
  return sharedSheet;
}

export function toggleStructureView() {
  structureViewEnabled = !structureViewEnabled;
}

export function isStructureViewEnabled(): boolean {
  return structureViewEnabled;
}

export function toggleNotesCollapse() {
  notesCollapsed = !notesCollapsed;
}

export function areNotesCollapsed(): boolean {
  return notesCollapsed;
}

export function setStylesView(value: boolean) {
  originalStylesEnabled = value;
}

export function toggleStylesView() {
  originalStylesEnabled = !originalStylesEnabled;
}

export function areOriginalStylesEnabled(): boolean {
  return originalStylesEnabled;
}

export const imagesObjectURLMap: Record<string, {filename: string, url: string, type: string}> = {}

export async function loadFonts(fontFiles: File[]) {
  await fontFiles.forEach(async (font) => {
    const buffer: ArrayBuffer = await font.arrayBuffer()
    const fontObject: opentype.Font = opentype.parse(buffer)

    const fontFamily = fontObject.names.fontFamily.en
    const fontFace = new FontFace(fontFamily, buffer)

    await fontFace.load() 
    document.fonts.add(fontFace)
  })
}